<template>
    <div class="tab" @click="clicked">
        {{name}}
    </div>
</template>
<script>
export default {
    props: {
        name: String
    },
    methods:{
        clicked: function(){
            this.$emit('clicked',this.name);
        }
    }
}
</script>

<style scoped>
.tab{
    display: inline-block;
    position: relative;
    align-self: baseline;
    width: 2.5cm;
    text-align: center;
    border: rgba(0, 0, 0, 0) solid 1px;
    margin-top: 10px;
    user-select: none;
}
.tab:hover{
    border:darkgrey solid 1px;
    background-color: rgba(0, 0, 0, 0.445);
}
</style>